var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageWrapDefault',{attrs:{"errorMessage":_vm.errorMessage,"successMessage":_vm.successMessage,"topActionButtonPrimary":_vm.$getCurrentUser && _vm.$getCurrentUser.role === 'admin'
      ? {
          text: 'Create New Agency',
          key: 'create'
        }
      : {},"topActionButtonSecondary":{
    text: 'Actions',
    key: 'actions',
    subItems: [{ title: 'Export Agencies', command: 'export-agencies' }]
  }},on:{"toolbarSelectItem":_vm.onToolbarItemClick,"errorMessageClosed":function($event){_vm.errorMessage = ''}}},[_c('ListAgenciesTable'),_c('ModalBase',{attrs:{"name":"exportAgenciesModal","size":"medium","clickToClose":false,"showClose":true,"title":"Export Agencies","position":"center"}},[_c('Exporter',{attrs:{"defaultType":"agencies"},on:{"exported":function($event){return _vm.$modal.hide('exportAgenciesModal')}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }